/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */
import Events from 'minivents';
import {ajax} from './ajax.js';

export const hub /*: Events */ = new Events();

/*:: type APISeashotVisibility = 'unpublished' | 'private' | 'unlisted' | 'public'; */
/*:: type APISeashotPreviewStatus =
  | 'queued'
  | 'processing'
  | 'processed'
  | 'failed'
  | 'timedout'; */
/*:: type APISeashotPreviewType = 'unknown' | 'image' | 'video'; */

/*:: type APIResourceLink<T: string> = {+type: T, +id: string}; */
/*:: type APIResourceRelationship<T: string> = {+data: APIResourceLink<T>}; */
/*:: type APIResource<T: string, A: Object, R: Object> = {
  +type: T,
  +id: string,
  +attributes?: A,
  +relationships?: R,
}; */
/*:: type APIUserRef = APIResourceRelationship<'users'>; */
/*:: type APISeashotRef = APIResourceRelationship<'seashots'>; */
/*:: type APIUser = APIResource<
  'users',
  {
    +label?: string,
    +joined_at?: number,
  },
  {
    +seashots?: APISeashotRef[],
  },
>; */
/*:: type APISeashot = APIResource<
  'seashots',
  {
    +created_at?: number,
    +updated_at?: number | null,
    +visibility?: APISeashotVisibility,
    +preview_status?: APISeashotPreviewStatus,
    +preview_type?: APISeashotPreviewType,
    +title?: string,
    +description?: string,
    +attributions?: string,
    +tags?: string[],
    +start_date?: number,
    +end_date?: number,
    +center_x?: number,
    +center_y?: number,
    +radius?: number,
    +url?: string,
    +likes_count?: number,
    +liked?: boolean | null,
  },
  {
    +author?: APIUserRef,
    // +users?: APIUserRef[],
  },
>; */

/*:: type APIErrorObject = {
  +id?: string,
  +status?: string,
  +code?: string,
  +title?: string,
  +detail?: string,
  +source?: {
    +pointer?: string,
    +parameter?: string,
  },
  +meta?: {},
}; */
/*:: type APIDataResponse<T> = {
  +data: T,
  +included?: (APIUser | APISeashot)[],
}; */
/*:: type APIErrorResponse = {errors: APIErrorObject[]}; */
/*:: type APIResponse<T> = APIDataResponse<T> | APIErrorResponse; */

/*:: type APIUserResponse = APIResponse<APIUser>; */
/*:: type APIUsersResponse = APIResponse<APIUser[]>; */
/*:: type APISeashotResponse = APIResponse<APISeashot>; */
/*:: type APISeashotsResponse = APIResponse<APISeashot[]>; */
/*:: type APISeashotIdsResponse = APIResponse<string[]>; */

/*:: export type APIError = Error & {
  +name: 'APIError',
  +errorObject: APIErrorObject,
}; */
/*:: export type APIErrors = Error & {
  +name: 'APIError',
  +errors: APIError[],
}; */

/*:: export type SeashotVisibility = APISeashotVisibility; */
/*:: export type SeashotPreviewStatus = APISeashotPreviewStatus; */
/*:: export type SeashotPreviewType = APISeashotPreviewType; */
/*:: export type User = {
  +type__: 'users',
  +id: string,
  +label: string,
  +joinedAt: Date,
  // +seashots?: Promise<Seashot>[],
}; */
/*:: export type Seashot = {
  +type__: 'seashots',
  +id: string,
  +createdAt: Date,
  +updatedAt: Date | null,
  +visibility: SeashotVisibility,
  +previewStatus: SeashotPreviewStatus,
  +previewType: SeashotPreviewType,
  +title: string,
  +description: string,
  +attributions: string,
  +tags: string[],
  +startDate: Date,
  +endDate: Date,
  +centerX: number,
  +centerY: number,
  +radius: number,
  +url: string,
  +likesCount: number,
  +liked: boolean,
  +author: Promise<User>,
  // +users?: Promise<User>[],
}; */
/*:: export type AuthUser = {
  +label: string,
  +email: string,
  +email_verified: boolean,
}; */

/*:: type ResourceTypes = {
  users: APIUser,
  seashots: APISeashot,
}; */
/*:: type ObjectTypes = {
  users: User,
  seashots: Seashot,
}; */

const resourcesById /*: {
  users: Map<string | null, User>,
  seashots: Map<string, Seashot>,
} */ = {
  users: new Map(),
  seashots: new Map(),
};

const resourcePromisesById /*: {
  users: Map<string | null, Promise<User>>,
  seashots: Map<string, Promise<Seashot>>,
} */ = {
  users: new Map(),
  seashots: new Map(),
};

function errorFromAPIError(errorObject /*: APIErrorObject */) /*: APIError */ {
  const error /*: any */ = new Error(errorObject.title);
  error.name = 'APIError';
  error.errorObject = errorObject;
  return error;
}
function errorFromAPIErrors(errors /*: APIErrorObject[] */) /*: APIErrors */ {
  const error /*: any */ = new Error(
    errors.length === 1 ? errors[0].title : 'API Error'
  );
  error.name = 'APIError';
  error.errors = errors.map(errorFromAPIError);
  return error;
}

function dateFromAPI(timestamp) {
  return timestamp == null ? timestamp : new Date(timestamp);
}
function dateToAPI(date) {
  return date?.getTime();
}

const fromResource /*: $ObjMapi<
  ObjectTypes,
  <T, OT>(
    T,
    OT
  ) => $ObjMap<
    $Rest<OT, {|type__: T|}>,
    <V>(V) => (resource: ResourceTypes[T]) => V,
  >,
> */ = {
  users: {
    id: ({id}) => id,
    label: ({attributes: {label} = {}}) => label,
    joinedAt: ({attributes: {joined_at} = {}}) => dateFromAPI(joined_at),
  },
  seashots: {
    id: ({id}) => id,
    createdAt: ({attributes: {created_at} = {}}) => dateFromAPI(created_at),
    updatedAt: ({attributes: {updated_at} = {}}) => dateFromAPI(updated_at),
    visibility: ({attributes: {visibility} = {}}) => visibility,
    previewStatus: ({attributes: {preview_status} = {}}) => preview_status,
    previewType: ({attributes: {preview_type} = {}}) => preview_type,
    title: ({attributes: {title} = {}}) => title,
    description: ({attributes: {description} = {}}) => description,
    attributions: ({attributes: {attributions} = {}}) => attributions,
    tags: ({attributes: {tags} = {}}) => tags,
    startDate: ({attributes: {start_date} = {}}) => dateFromAPI(start_date),
    endDate: ({attributes: {end_date} = {}}) => dateFromAPI(end_date),
    centerX: ({attributes: {center_x} = {}}) => center_x,
    centerY: ({attributes: {center_y} = {}}) => center_y,
    radius: ({attributes: {radius} = {}}) => radius,
    url: ({attributes: {url} = {}}) => url,
    likesCount: ({attributes: {likes_count} = {}}) => likes_count,
    liked: ({attributes: {liked} = {}}) => liked || false,
    author: ({relationships: {author} = {}}) =>
      author && getUserWithId(author.data.id),
  },
};
const toResource /*: $ObjMapi<
  ResourceTypes,
  <T, RT>(
    T,
    RT
  ) => {
    type: T,
    id: (object: ObjectTypes[T]) => ObjectTypes[T]['id'],
    attributes?: $ObjMap<
      $NonMaybeType<RT['attributes']>,
      <V>(V) => (object: ObjectTypes[T]) => V,
    >,
  },
> */ = {
  users: {
    type: 'users',
    id: ({id}) => id,
    attributes: {
      label: ({label}) => label,
      joined_at: ({joinedAt}) => dateToAPI(joinedAt),
    },
  },
  seashots: {
    type: 'seashots',
    id: ({id}) => id,
    attributes: {
      visibility: ({visibility} = {}) => visibility,
      title: ({title} = {}) => title,
      description: ({description} = {}) => description,
      attributions: ({attributions} = {}) => attributions,
      tags: ({tags} = {}) => tags,
      start_date: ({startDate} = {}) => dateToAPI(startDate),
      end_date: ({endDate} = {}) => dateToAPI(endDate),
      center_x: ({centerX} = {}) => centerX,
      center_y: ({centerY} = {}) => centerY,
      radius: ({radius} = {}) => radius,
      url: ({url} = {}) => url,
      liked: ({liked} = {}) => liked || false,
    },
  },
};

export let authUser /*: ?AuthUser */ = window.__user;

function objectFromResource /*:: <T: $Values<ResourceTypes>> */(
  resource /*: T */
) /*: $Shape<ObjectTypes[T['type']]> */ {
  const {type} = resource;
  const object = {};
  for (const [key, get] of Object.entries(fromResource[type])) {
    const value = (get /*: Function */)(resource);
    if (value !== undefined) {
      object[key] = value;
    }
  }
  return object;
}

function objectToResource /*:: <T: $Values<ObjectTypes>> */(
  object /*: T */
) /*: ResourceTypes[T['type__']] */ {
  const type = object.type__;
  const attributes = {};
  let hasAttributes = false;
  for (const [key, get] of Object.entries(toResource[type].attributes || {})) {
    const value = (get /*: Function */)(object);
    if (value !== undefined) {
      attributes[key] = value;
      hasAttributes = true;
    }
  }
  const resource /*: any */ = {type, id: toResource[type].id((object /*: any */))};
  if (hasAttributes) {
    resource.attributes = attributes;
  }
  return resource;
}
function userToResource(partial) {
  return objectToResource({type__: 'users', ...partial});
}
function seashotToResource(partial) {
  return objectToResource({type__: 'seashots', ...partial});
}

/*:: declare function handleAPIResource<R>(resource: R): ObjectTypes[R['type']]; */
function handleAPIResource(resource) {
  const {type, id} = resource;
  const object = objectFromResource(resource);
  const mergedObject = Object.assign(resourcesById[type].get(id) || {}, object);
  resourcesById[type].set(id, mergedObject);
  return mergedObject;
}

/*:: declare function handleAPIResponse(response: APIUserResponse): User; */
/*:: declare function handleAPIResponse(response: APIUsersResponse): User[]; */
/*:: declare function handleAPIResponse(response: APISeashotResponse): Seashot; */
/*:: declare function handleAPIResponse(response: APISeashotsResponse): Seashot[]; */
function handleAPIResponse(response) {
  if (response.errors) {
    throw errorFromAPIErrors(response.errors);
  }

  const {data, included} = response;

  if (Array.isArray(included)) {
    included.map(handleAPIResource);
  }
  if (Array.isArray(data)) {
    return data.map(handleAPIResource);
  }
  return handleAPIResource(data);
}

export function isAPIError(error /*: any */) /*: boolean %checks */ {
  return error instanceof Error && error.name === 'APIError';
}

export const handlePageData = handleAPIResponse;

export function getAuthUser(forceFetch /*: boolean */ = false) /*: Promise<User> */ {
  if (!forceFetch) {
    const user = resourcesById.users.get(null);
    if (user) {
      return Promise.resolve(user);
    }

    const userPromise = resourcePromisesById.users.get(null);
    if (userPromise) {
      return userPromise;
    }
  }

  const userPromise = fetchAuthUser();
  resourcePromisesById.users.set(null, userPromise);
  userPromise.then((u) => resourcesById.users.set(null, u));
  return userPromise;
}
export function getUserWithId(
  id /*: string */,
  forceFetch /*: boolean */ = false
) /*: Promise<User> */ {
  if (!forceFetch) {
    const user = resourcesById.users.get(id);
    if (user) {
      return Promise.resolve(user);
    }

    const userPromise = resourcePromisesById.users.get(id);
    if (userPromise) {
      return userPromise;
    }
  }

  const userPromise = fetchUserWithId(id);
  resourcePromisesById.users.set(id, userPromise);
  return userPromise;
}
export function getSeashotWithId(
  id /*: string */,
  forceFetch /*: boolean */ = false
) /*: Promise<Seashot> */ {
  if (!forceFetch) {
    const seashot = resourcesById.seashots.get(id);
    if (seashot) {
      return Promise.resolve(seashot);
    }

    const seashotPromise = resourcePromisesById.seashots.get(id);
    if (seashotPromise) {
      return seashotPromise;
    }
  }

  const seashotPromise = fetchSeashotWithId(id);
  resourcePromisesById.seashots.set(id, seashotPromise);
  return seashotPromise;
}
export function refreshSeashotPreviewWithId(id /*: string */) /*: Promise<Seashot> */ {
  const seashotPromise = fetchSeashotWithId(id, {
    'fields[seashots]': ['preview_type', 'preview_status'],
  });
  resourcePromisesById.seashots.set(id, seashotPromise);
  return seashotPromise;
}

export function getSeashotsWithIds(ids /*: string[] */) /*: Promise<Seashot>[] */ {
  const idsToLoad = [];
  const promises = [];
  const promisesById = {resolve: {}, reject: {}};

  for (const id of ids) {
    let seashotPromise /*: ?Promise<Seashot> */;
    const seashot = resourcesById.seashots.get(id);
    if (seashot) {
      seashotPromise = Promise.resolve(seashot);
    } else {
      seashotPromise = resourcePromisesById.seashots.get(id);
    }
    if (!seashotPromise) {
      idsToLoad.push(id);
      seashotPromise = new Promise(function (resolve, reject) {
        promisesById.resolve[id] = resolve;
        promisesById.reject[id] = reject;
      });
      resourcePromisesById.seashots.set(id, seashotPromise);
    }
    promises.push(seashotPromise);
  }

  loadSeashotsWithIds(idsToLoad, promisesById);
  return promises;
}
async function loadSeashotsWithIds(ids, promisesById) {
  if (ids.length === 0) {
    return;
  }

  try {
    const seashots = await fetchSeashotsWithIds(ids);

    for (const seashot of seashots) {
      promisesById.resolve[seashot.id](seashot);
      delete promisesById.resolve[seashot.id];
    }

    for (const id in promisesById.resolve) {
      if (Object.hasOwn(promisesById.resolve, id)) {
        promisesById.reject[id]();
      }
    }
  } catch (error) {
    for (const id in promisesById.reject) {
      if (Object.hasOwn(promisesById.reject, id)) {
        promisesById.reject[id](error);
      }
    }
  }
}

export function login() /*: void */ {
  const newHref = window.location.href.replace(
    /^(.*:\/\/[^/]+)(\/[^?#]*(?:\?[^#]*)?(?:#.*)?)?$/,
    function (match, origin, rest) {
      return `${origin}/login?return_uri=${encodeURIComponent(rest)}`;
    }
  );
  window.location = newHref;
}

export function logout() /*: void */ {
  const newHref = window.location.href.replace(
    /^(.*:\/\/[^/]+)(\/[^?#]*(?:\?[^#]*)?(?:#.*)?)?$/,
    function (match, origin, rest) {
      return `${origin}/logout`;
    }
  );
  window.location = newHref;
}

async function apiAjax(url, options) {
  try {
    const response = await ajax(url, options);
    updateAuthedUser(response);
    return response;
  } catch (error) {
    if (error.response) {
      updateAuthedUser(error.response);
    }
    throw error;
  }
}
function bool(value) {
  return typeof value === 'string' ? value !== 'false' : !!value;
}
function updateAuthedUser(response) {
  const newAuthUser = response.headers['x-auth-user-email']
    ? {
        label: response.headers['x-auth-user-label'],
        email: response.headers['x-auth-user-email'],
        email_verified: bool(response.headers['x-auth-user-email-verified']),
      }
    : null;
  if (
    authUser?.label === newAuthUser?.label
    && authUser?.email === newAuthUser?.email
    && authUser?.email_verified === newAuthUser?.email_verified
  ) {
    return;
  }

  authUser = newAuthUser;
  hub.emit('change:authUser');
}

export async function sendVerificationEmail() /*: Promise<void> */ {
  await apiAjax('/user/send_verification_email');
}

export async function resetPassword() /*: Promise<void> */ {
  await apiAjax('/user/reset_password');
}

/*:: type JSONValue =
  | string
  | number
  | null
  | {[key: string]: JSONValue}
  | JSONValue[]; */

async function getJSON /*:: <T: JSONValue> */(
  url,
  options,
  signal /*: ?AbortSignal */
) /*: Promise<T> */ {
  const response = await apiAjax(url, {
    method: 'GET',
    headers: {accept: 'application/json'},
    responseType: 'json',
    signal,
    ...options,
  });
  return response.body;
}
async function patch /*:: <T: JSONValue> */(
  url,
  options,
  signal /*: ?AbortSignal */
) /*: Promise<T> */ {
  const response = await apiAjax(url, {
    method: 'PATCH',
    headers: {accept: 'application/json'},
    responseType: 'json',
    signal,
    ...options,
  });
  return response.body;
}

export async function getSeashotIds(
  searchQuery /*: string */,
  tag /*: string | undefined */,
  onData /*: (newData: string) => void */,
  onEnd /*: () => void */
) /*: Promise<void> */ {
  const sortBy = ['-created_at'];
  await apiAjax('/apiv1/seashots', {
    data: {
      'fields[seashots]': '',

      filter: searchQuery,
      sort: sortBy.join(','),

      ...(tag && {'filter[tags]': tag}),
    },
    headers: {accept: 'text/plain'},
    progress: onData,
  });
  onEnd();
}

async function fetchAuthUser() /*: Promise<User> */ {
  return handleAPIResponse(await getJSON(`/apiv1/user`));
}
async function fetchUserWithId(id /*: string */) /*: Promise<User> */ {
  return handleAPIResponse(await getJSON(`/apiv1/users/${id}`));
}
async function fetchSeashotWithId(
  id /*: string */,
  data /*: any */ = {include: 'author'}
) /*: Promise<Seashot> */ {
  return handleAPIResponse(await getJSON(`/apiv1/seashots/${id}`, {data}));
}
async function fetchSeashotsWithIds(ids /*: string[] */) /*: Promise<Seashot[]> */ {
  if (ids.length === 0) {
    return [];
  }
  if (ids.length === 1) {
    return [await fetchSeashotWithId(ids[0])];
  }
  return handleAPIResponse(
    await getJSON(`/apiv1/seashots/${ids.join(',')}`, {
      data: {include: 'author'},
    })
  );
}
export async function updateAuthUser(updates /*: $Shape<User> */) /*: Promise<User> */ {
  return handleAPIResponse(
    await patch(`/apiv1/user`, {
      data: {data: userToResource(updates)},
      dataType: 'json',
      responseType: 'json',
    })
  );
}
export async function updateSeashotWithId(
  id /*: string */,
  updates /*: $Shape<Seashot> */
) /*: Promise<Seashot> */ {
  return handleAPIResponse(
    await patch(`/apiv1/seashots/${id}`, {
      data: {data: seashotToResource({id, ...updates})},
      dataType: 'json',
      responseType: 'json',
    })
  );
}
export function likeSeashotWithId(
  id /*: string */,
  liked /*: boolean */
) /*: Promise<Seashot> */ {
  return updateSeashotWithId(id, {liked});
}
export async function deleteSeashotWithId(id /*: string */) /*: Promise<void> */ {
  await apiAjax(`/apiv1/seashots/${id}`, {method: 'DELETE'});
}
